import { portalApi } from "./client";
import type {
  BrokerApplicationDto,
  BrokerApplicationResubmitDto,
  BrokerApplicationSubmitResponseDto,
  BrokerMaterialsResponse,
  BrokerPortalDashboardDto,
  OnboardingCourseDto,
  OnboardingProgressDto,
  PortalMaterialDownloadDto,
  ResubmitBrokerApplicationRequest,
  SubmitBrokerApplicationRequest,
} from "./types";

// Broker portal HTTP client. Anonymous application submit lives under
// /api/portal/broker/* (the controller marks it AllowAnonymous +
// rate-limits it). Every other endpoint requires a broker Portal-scheme
// session; the API enforces Kind=Broker on every call.
//
// Deal submission moved to a dedicated client in dealSubmission.ts — the
// wizard endpoints live under /broker/deals/submissions/*.

export const brokerApi = {
  submitApplication: (body: SubmitBrokerApplicationRequest) =>
    portalApi.post<BrokerApplicationSubmitResponseDto>("/broker/applications/submit", body),

  getResubmitApplication: (token: string) =>
    portalApi.get<BrokerApplicationResubmitDto>(`/broker/applications/resubmit/${token}`),
  resubmitApplication: (token: string, body: ResubmitBrokerApplicationRequest) =>
    portalApi.post<BrokerApplicationDto>(`/broker/applications/resubmit/${token}`, body),

  dashboard: () => portalApi.get<BrokerPortalDashboardDto>("/broker/dashboard"),
  getCourse: () => portalApi.get<OnboardingCourseDto | null>("/broker/onboarding/course"),
  getProgress: () => portalApi.get<OnboardingProgressDto>("/broker/onboarding/progress"),
  attestItem: (itemId: string) =>
    portalApi.post<OnboardingProgressDto>("/broker/onboarding/attest", { itemId }),

  listMaterials: () => portalApi.get<BrokerMaterialsResponse>("/broker/materials"),
  downloadMaterial: (id: string) =>
    portalApi.get<PortalMaterialDownloadDto>(`/broker/materials/${id}/download`),
  materialPreviewUrl: (id: string) => `/api/portal/broker/materials/${id}/preview`,
};
